import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/@Auth/auth-material/auth.service';
import { CommanServiceService } from '../service/comman-service.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  showAdminDrop:boolean = false;
  showLanguage:boolean = false;
  userName: string = '';
  @Input()
  sidebarCloseOpen: any = false;
  @Output()
  sidebarshrink: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private _authService:AuthService,
    private toster:ToastrService,
     private readonly command_service:CommanServiceService){

  }

  ngOnInit(): void {
    const session = this._authService.getUserSession();
    this.userName = session?.user_name || 'Assurer';
  }

  logOut(e:any){
    e.stopPropagation();
    this.showAdminDrop = false;
    this._authService.logout();
  };

  adminClick(e:any){
    e.stopPropagation();
    this.showAdminDrop = !this.showAdminDrop
    if(this.showLanguage){
      this.showLanguage = false;
    };
  };

  languageClick(e:any){
    e.stopPropagation();
    this.showLanguage = !this.showLanguage
    if(this.showAdminDrop){
      this.showAdminDrop = false;
    }
  };

  profile(e:any){
    e.stopPropagation();
    this.showAdminDrop = false;
    this.toster.info('Coming Soon');
  };

  changeLanguage(e:any,lang:any){
    e.stopPropagation();
    this.showLanguage = false;
    if(lang =='sp'){
      this.toster.info('Coming Soon');
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event:any) {
    if(this.showAdminDrop || this.showLanguage){
      this.showAdminDrop = false;
      this.showLanguage = false;
    };
  };

  toggleLeftMenu(e:any){
    e.stopPropagation();
  }
}
